export const getImageDescription = (alt?: string) => {
  // It is recommend to end the description with a period.
  // > End the alt-text with a period. This will make screen readers pause a bit
  //   after the last word in the alt-text, which creates a more pleasant
  //   reading experience for the user.
  // — https://axesslab.com/alt-texts
  if (
    typeof alt !== 'string' ||
    alt.length === 0 ||
    alt.trim().match(/[.!?…]$/)
  ) {
    return alt
  }

  return alt.trim() + '.'
}
